import { render, staticRenderFns } from "./ReturnGoods2.vue?vue&type=template&id=35fe3884&scoped=true&"
import script from "./ReturnGoods2.vue?vue&type=script&lang=js&"
export * from "./ReturnGoods2.vue?vue&type=script&lang=js&"
import style0 from "./ReturnGoods2.vue?vue&type=style&index=0&id=35fe3884&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe3884",
  null
  
)

export default component.exports